export default {"src":"/_next/static/media/detailed.f9de0bce.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};